/**
 * 各ポップアップ内に固有の情報をもたせたい場合に利用する
 * optionの値が存在しない場合、参照エラーになる可能性があるの空の配列/オブジェクトを用意しておくこと。
 * また、Optionsを利用する側でも値がない場合を考慮しておくこと。
 * ES2020のoptional-chainingを利用すると楽にチェックできる（babel7にて実装済み）
 * http://kangax.github.io/compat-table/es2016plus/
 *
 * このOptionsファイルが肥大化してきた場合は、
 * ・itemの文字幅でcssを変更し、列の調整を行う
 * ・コンポーネントの個別化を行う（例：businessTypesPopupとskillCoursesPopupを作る）
 * など、Reactコンポーネント内で完結する処理の実装を考えること。
 *
 * param説明
 * 使用するポップアップ: {
 *   title: 使用するポップアップのタイトル,
 *   iconClass: iconが指定されているclass名,
 *   sectionTypes（大項目群）: [
 *     {
 *       id: 1,
 *       numberOfColumns（何列で表示させるか default: 2）: 4,
 *     },
 *   ],
 *   items（セレクトボックスで表示する項目群）: [
 *     {
 *       id: 10,
 *       sectionTypeId: 1,
 *       usingOfColumns（何列利用するか default: 1）: 2,
 *     }
 *   ]
 * }
 *
 */
const OPTIONS = {
  recruitmentPrTypes: {
    title: "募集PR内容を選択",
    prMessages: {
      pc: {
        limitedItem: "※「求人・発注記事」と「求職・受注記事」で選択できるPR項目は変わります。"
      },
      sp: {
        limitedItem: "※「求人・発注記事」と「求職・受注記事」で\n選択できるPR項目は変わります。"
      }
    },
    // アイコン設定が要修正
    iconClass: "recruitment_pr mypage-edit",
    // 大項目群が要修正
    sectionTypes: [
      {
        id: 1,
        numberOfColumns: 3,
      },
      {
        id: 2,
        numberOfColumns: 3,
      },
      {
        id: 3,
        numberOfColumns: 3,
      },
      {
        id: 4,
        numberOfColumns: 3,
      },
      {
        id: 5,
        numberOfColumns: 3
      }
    ],
    items: []
  },
  businessTypes: {
    title: "業種・職種を選択",
    messages: {
      pc: {
        limitedItem: "業種は3つまで選択できます。4つ以上は選択できません。"
      },
      sp: {
        limitedItem: "業種は3つまで選択できます。\n4つ以上は選択できません。"
      }
    },
    iconClass: "industry mypage-edit",
    sectionTypes: [
      {
        id: 1,
        numberOfColumns: 4,
      },
      {
        id: 3,
        numberOfColumns: 3,
      }
    ],
    items: [
      {
        id: 10,
        sectionTypeId: 1,
        usingOfColumns: 2,
      }
    ]
  },
  qualifications: {
    title: "資格・免許を選択",
    iconClass: "licence mypage-edit",
    sectionTypes: [
      {
        id: 1,
        numberOfColumns: 2,
      },
      {
        id: 2,
        numberOfColumns: 2,
      },
      {
        id: 3,
        numberOfColumns: 2,
      },
      {
        id: 4,
        numberOfColumns: 2,
      },
      {
        id: 5,
        numberOfColumns: 2,
      },
      {
        id: 6,
        numberOfColumns: 2,
      },
      {
        id: 7,
        numberOfColumns: 2,
      }
    ],
    items: []
  },
  skillCourses: {
    title: "技能・講習を選択",
    iconClass: "skill mypage-edit",
    sectionTypes: [
      {
        id: 1,
        numberOfColumns: 3,
      },
      {
        id: 2,
        numberOfColumns: 3,
      },
      {
        id: 3,
        numberOfColumns: 3,
      }
    ],
    items: [
      {
        id: 42,
        sectionTypeId: 2,
        usingOfColumns: 2,
      },
      {
        id: 68,
        sectionTypeId: 3,
        usingOfColumns: 2,
      }
    ]
  },
  areas: {
    title: "活動地域を選択",
    iconClass: "area mypage-edit",
    sectionTypes: [
      {
        id: 1,
        numberOfColumns: 4
      },
      {
        id: 2,
        numberOfColumns: 4
      },
      {
        id: 3,
        numberOfColumns: 4
      },
      {
        id: 4,
        numberOfColumns: 4
      },
      {
        id: 5,
        numberOfColumns: 4
      },
      {
        id: 6,
        numberOfColumns: 4
      }
    ],
    items: [
      {
        id: 48,
        sectionTypeId: 2,
        usingOfColumns: 3,
      },
      {
        id: 49,
        sectionTypeId: 2,
        usingOfColumns: 3,
      },
      {
        id: 50,
        sectionTypeId: 3,
        usingOfColumns: 3,
      },
      {
        id: 51,
        sectionTypeId: 4,
        usingOfColumns: 3,
      },
      {
        id: 52,
        sectionTypeId: 6,
        usingOfColumns: 3,
      }
    ]
  }
};

Object.freeze(OPTIONS);
export default OPTIONS;